(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (() => {
    const sectionRoot = document.currentScript?.closest('.shopify-section');
    if (!sectionRoot) return;

    const emberContainer = sectionRoot.querySelector('[data-embers]');
    if (!emberContainer) return;

    const colors = ['#ff571a', '#ffb59e', '#ffdb3c'];

    for (let index = 0; index < 40; index += 1) {
      const ember = document.createElement('span');
      const size = Math.random() * 4 + 1;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const drift = `${Math.random() * 200 - 100}px`;
      const duration = `${Math.random() * 10 + 10}s`;
      const delay = `${Math.random() * 5}s`;

      ember.className = 'error-page__ember';
      ember.style.width = `${size}px`;
      ember.style.height = `${size}px`;
      ember.style.left = `${Math.random() * 100}%`;
      ember.style.top = `${Math.random() * 100}%`;
      ember.style.backgroundColor = color;
      ember.style.boxShadow = `0 0 10px ${color}`;
      ember.style.setProperty('--ember-drift', drift);
      ember.style.setProperty('--ember-duration', duration);
      ember.style.setProperty('--ember-delay', delay);

      emberContainer.appendChild(ember);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (() => {
    const sectionRoot = document.currentScript?.closest('.shopify-section');
    if (!sectionRoot) return;
    if (sectionRoot.querySelector('.blog-hub')?.classList.contains('blog-hub--no-reveal')) return;

    const revealItems = sectionRoot.querySelectorAll('.blog-hub__reveal');
    if (!revealItems.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    revealItems.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const sectionRoot = document.currentScript?.closest('.shopify-section');
    if (!sectionRoot) return;

    const header = sectionRoot.querySelector('.header');
    const toggle = sectionRoot.querySelector('[data-mobile-toggle]');
    const mobileMenu = sectionRoot.querySelector('[data-mobile-menu]');

    if (!header || !toggle || !mobileMenu) return;

    function closeMenu() {
      header.classList.remove('is-mobile-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      header.classList.add('is-mobile-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', () => {
      if (header.classList.contains('is-mobile-open')) closeMenu();
      else openMenu();
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionRoot = document.currentScript?.closest('.shopify-section');
    if (!sectionRoot) return;

    const cards = Array.from(sectionRoot.querySelectorAll('.shop-card'));
    if (!cards.length) return;

    const categoryButtons = Array.from(sectionRoot.querySelectorAll('.shop-sidebar__category[data-category]'));
    const blendButtons = Array.from(sectionRoot.querySelectorAll('.shop-sidebar__chip[data-blend]'));
    const intensityInput = sectionRoot.querySelector('[data-intensity]');
    const intensityLabel = sectionRoot.querySelector('[data-intensity-label]');
    const clearButton = sectionRoot.querySelector('[data-clear-filters]');
    const filteredEmpty = sectionRoot.querySelector('[data-filter-empty]');
    const intensityLowLabel = sectionRoot.dataset.intensityLowLabel || 'Smooth';
    const intensityMidLabel = sectionRoot.dataset.intensityMidLabel || 'Balanced';
    const intensityHighLabel = sectionRoot.dataset.intensityHighLabel || 'Extreme';

    const PARAM_CATEGORY = 'sp_cat';
    const PARAM_BLEND = 'sp_blend';
    const PARAM_HEAT = 'sp_heat';

    const VALID_CATEGORIES = ['all', ...categoryButtons.map((btn) => btn.dataset.category || '').filter(Boolean)];
    const VALID_BLENDS = ['fronto', 'red-rose', 'hot-grabba', 'dutch'];
    const CATEGORY_ALIASES = {
      'whole-leaf': 'leaf',
      'crushed-blended': 'shakers-and-shredded'
    };

    let activeCategory = 'all';
    let activeBlend = '';

    function getParams() {
      return new URLSearchParams(window.location.search);
    }

    function updateIntensityLabel(value) {
      if (!intensityLabel) return;

      if (value < 33) {
        intensityLabel.textContent = intensityLowLabel;
      } else if (value < 66) {
        intensityLabel.textContent = intensityMidLabel;
      } else {
        intensityLabel.textContent = intensityHighLabel;
      }
    }

    function updateUrl() {
      const params = getParams();
      const heat = Number(intensityInput?.value || 30);

      if (activeCategory !== 'all') params.set(PARAM_CATEGORY, activeCategory);
      else params.delete(PARAM_CATEGORY);

      if (activeBlend) params.set(PARAM_BLEND, activeBlend);
      else params.delete(PARAM_BLEND);

      if (heat !== 30) params.set(PARAM_HEAT, String(heat));
      else params.delete(PARAM_HEAT);

      const qs = params.toString();
      const nextUrl = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', nextUrl);
    }

    function applyFilters(syncUrl = true) {
      const heat = Number(intensityInput?.value || 30);
      const threshold = Math.max(1, Math.ceil(heat / 20));

      let visibleCount = 0;

      cards.forEach((card) => {
        const cardCategory = card.dataset.category || 'all';
        const cardTags = card.dataset.tags || '';
        const cardHeat = Number(card.dataset.heat || 0);

        const categoryPass = activeCategory === 'all' || cardCategory === activeCategory;
        const blendPass = !activeBlend || cardTags.includes(activeBlend);
        const heatPass = cardHeat >= threshold;

        const show = categoryPass && blendPass && heatPass;
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCount += 1;
      });

      if (filteredEmpty) filteredEmpty.classList.toggle('is-hidden', visibleCount > 0);

      updateIntensityLabel(heat);
      if (syncUrl) updateUrl();
    }

    function activateCategory(category) {
      activeCategory = category;
      categoryButtons.forEach((btn) => {
        btn.classList.toggle('shop-sidebar__category--active', btn.dataset.category === category);
      });
    }

    function activateBlend(blend) {
      activeBlend = blend;
      blendButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.blend === blend && !!blend);
      });
    }

    function hydrateFromUrl() {
      const params = getParams();
      const cat = params.get(PARAM_CATEGORY);
      const blend = params.get(PARAM_BLEND);
      const heat = Number(params.get(PARAM_HEAT));
      const normalizedCat = CATEGORY_ALIASES[cat] || cat;

      if (normalizedCat && VALID_CATEGORIES.includes(normalizedCat)) activateCategory(normalizedCat);
      else activateCategory('all');

      if (blend && VALID_BLENDS.includes(blend)) activateBlend(blend);
      else activateBlend('');

      if (intensityInput) {
        const normalizedHeat = Number.isFinite(heat) ? Math.max(1, Math.min(100, heat)) : 30;
        intensityInput.value = String(normalizedHeat);
      }
    }

    categoryButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        activateCategory(btn.dataset.category || 'all');
        applyFilters(true);
      });
    });

    blendButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const blend = btn.dataset.blend || '';
        if (activeBlend === blend) activateBlend('');
        else activateBlend(blend);
        applyFilters(true);
      });
    });

    intensityInput?.addEventListener('input', () => applyFilters(true));

    clearButton?.addEventListener('click', () => {
      activateCategory('all');
      activateBlend('');
      if (intensityInput) intensityInput.value = '30';
      applyFilters(true);
    });

    window.addEventListener('popstate', () => {
      hydrateFromUrl();
      applyFilters(false);
    });

    hydrateFromUrl();
    applyFilters(true);
  })();

  } catch(e) { console.error(e); }
})();
})();
